import script from "./Layout9.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layout9.vue?vue&type=script&lang=ts&setup=true"

import "./Layout9.vue?vue&type=style&index=0&id=59aca43f&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59aca43f"]])

export default __exports__